/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContentFilterType } from './contentFilterType';
import { Direction } from './direction';
import { ServiceBillingType } from './serviceBillingType';
import { VasServiceTypeEnum } from './vasServiceTypeEnum';


export interface MTMOFilter { 
    id: string;
    serviceName?: string;
    shouldPerformTelcoBilling: boolean;
    shortCodePhoneNumber?: string;
    networkOperatorCode?: string;
    direction: Direction;
    contentFilterType: ContentFilterType;
    contentFilterTypeName?: string;
    filterExpression?: string;
    shouldFilterExpressionRequireSpace: boolean;
    isCaseSensitive: boolean;
    industry?: string;
    industryCode?: string;
    serviceTypeName?: string;
    creatorId?: string;
    serviceType: VasServiceTypeEnum;
    contentProviderSmsRouteName?: string;
    smsRouteName?: string;
    contentPartnerName?: string;
    dateCreated: Date;
    serviceFee: number;
    billingType: ServiceBillingType;
    serviceBillingProvider?: string;
    networkCode?: string;
    routeTypeName?: string;
    country?: string;
    countryCode?: string;
    mnc?: string;
    mcc?: string;
}
